<template>
  <div class="modal-header-input" :style="{ height: height + 'px' }" ref="autoCompleteShopMap">
    <div class="modal-header-input__phone-indent"></div>
    <div class="modal-header-input__inner d-flex justify-space-between align-center">
      <div style="width: 100%; height: 100%;">
        <label>
          <input
            v-model="vModel"
            class="modal-header-input__input"
            :placeholder="$t('modals.vModalHeaderInput.placeholder')"
            ref="autocompleteModalInput"
            @keydown.enter="$emit('keydown:enter')"
          >
        </label>
      </div>
      <div class="text--medium">
        <button @click.prevent="$emit('click')" class="d-block modal-header-input__button"><i class="icon-close"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import vModel from '@/mixins/vModel'

export default {
  mixins: [vModel],

  props: {
    autofocus: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 70
    },
    value: {
      type: String,
      default: null
    }
  },

  computed: {
    vModel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  mounted () {
    if (this.autofocus) {
      setTimeout(() => {
        this.$refs.autocompleteModalInput.focus()
      }, 200)
    }
  }
}
</script>

<style lang="scss">
.modal-header-input {
  &__inner {
    width: 100%;
  }

  &__phone-indent {
    /* Высота статус-бара в iOS 11+ */
    padding-top: env(safe-area-inset-top);
  }

  &__input {
    border: none;
    height: 100%;
    width: 100%;
    display: block;
    padding: 2rem;
    font-size: 1.4rem;
    border-right: 1px solid $color-grey-lighten;
    border-radius: 0;

    &:focus {
      border: none;
      outline: none;
      border-right: 1px solid $color-grey-lighten;
    }
  }

  &__button {
    height: 100%;
    width: 100%;
    padding: 2rem 2rem;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    color: $color-grey;
    font-weight: 600;
    font-size: 2rem;
  }
}
</style>
